import { out } from "@/lib/output/out";
import type { Batch } from "@/commands/batch/batch";
import { printBatchQuestion } from "@/commands/batch/print-batch-question";
export function printBatch(batch: Batch): void {
  // Questions are agent-authored text — sanitise before printing (out.safe).
  out.line(
    `${out.paint(out.cell(batch.sessionTitle), "bold")}  ${out.paint(`round ${batch.round}`, "dim")}`,
  );
  out.line(
    out.paint(
      `batch ${out.cell(batch.id)} · session ${out.cell(batch.sessionId)}`,
      "dim",
    ),
  );

  for (const question of batch.questions) {
    printBatchQuestion(question);
  }
}
